<template>
  <div class="integrations-loading">
    <img
      src="/wp-content/themes/snappy-theme/assets/images/crms/spinner.svg"
      class="img-fluid integrations-loading__spinner mb-5"
      alt="Success"
    />
    <h2 class="iintegrations-loading__heading">Please wait while your account is being authorized</h2>

    <p>This should only take a few seconds 😊</p>
    <a href="/integrations/catalogue/disconnect" class="integrations-loading__link">Cancel connection</a>
  </div>
</template>

<script>
export default {
  name: 'integrations-loading',
  data() {
    return {};
  },
};
</script>

<style lang="scss" scoped>
@import '../../../sass/web/_variables.scss';

.integrations-loading {
  padding: 106px 16px;
  &__spinner {
    margin: 0 auto;
    width: 150px;
    height: 150px;
  }
  &__heading {
    font-size: 28px;
    color: $mine-shaft-color;
    @media (min-width: $breakpoint-sm) {
      font-size: 48px;
    }
  }
  &__link {
    font-weight: 700;
    color: $half-baked-color;
  }
}
</style>
